import React from 'react';
import { string, func, bool } from 'prop-types';
import styles from './styles/styles.module.scss';
import FavoriteButton from '../../../../../../../components/shared/FavoriteButton';

const ListTableRow = ({ imgUrl, listTitle, handleFavoriteClick, isFavorite, listContents }) => {
  return (
    <tr className={styles.container}>
      <td className={styles.imageContainer}>
        <img className={styles.listImage} src={imgUrl} alt={listTitle} />
      </td>
      <td>
        <div className={styles.name}>{listTitle}</div>
        <div className={styles.contains}>{listContents}</div>
      </td>
      <td className={styles.favoriteButtonContainer}>
        <FavoriteButton onWhiteBg handleFavoriteClick={handleFavoriteClick} isFavorite={isFavorite} />
      </td>
    </tr>
  );
};

ListTableRow.propTypes = {
  imgUrl: string,
  listTitle: string,
  handleFavoriteClick: func.isRequired,
  isFavorite: bool,
  listContents: string
};

ListTableRow.defaultProps = {
  imgUrl: '',
  listTitle: '',
  isFavorite: false,
  listContents: ''
};

export default ListTableRow;
